
import ObjectFitClass from "utils/_object-fit";

var $ = jQuery;

export default class ArticleArchive {

    constructor() {

		this.WRAPPER = document.querySelector('.mtt-articles-widget--all');
		if (!this.WRAPPER) return;

		this.ARTICLES_WRAP = document.getElementById('mtt-articles-widget-posts');
		this.PAGINATION_WRAP = document.getElementById('mtt-articles-widget-pagination');
		this.CATEGORIES = this.WRAPPER.querySelectorAll('.mtt-articles-widget__filter-toggle');
		this.LOADER = this.WRAPPER.querySelector('.mtt-articles-widget__loader');
		this.SCROLL_TO_ID = '#mtt-articles-widget-scrollto';
		this.ACTIVE_TOGGLE = this.WRAPPER.querySelector('.mtt-articles-widget__filter-toggle--active')

		this.url = this.WRAPPER.getAttribute('data-main-url');
		this.data = {
			'action': 'filter_articles',
			'category': this.ACTIVE_TOGGLE ? this.ACTIVE_TOGGLE.getAttribute('data-category') : null,
			'pagenumber': 1
		};

		this.categoriesHandler();
		this.paginationToggleHandler();
	}

	categoriesHandler() {
		if (this.CATEGORIES.length === 0) return;

		for (let i = 0; i < this.CATEGORIES.length; i++) {
			const TOGGLE = this.CATEGORIES[i];

			TOGGLE.addEventListener('click', () => {
				this.data.category = TOGGLE.getAttribute('data-category');
				this.data.pagenumber = 1;

				for (let i = 0; i < this.CATEGORIES.length; i++) {
					this.CATEGORIES[i].classList.remove('mtt-articles-widget__filter-toggle--active');
				}
				TOGGLE.classList.add('mtt-articles-widget__filter-toggle--active');

				this.filterArticles();

				this.buildUrl();
			});
		}
	}

	paginationToggleHandler() {
		const PAGINATION_TOGGLES = document.querySelectorAll('#mtt-articles-widget-pagination .mtt-pagination__toggle');
		if (PAGINATION_TOGGLES.length === 0) {
			return;
		}

		for (let i = 0; i < PAGINATION_TOGGLES.length; i++) {
			const TOGGLE = PAGINATION_TOGGLES[i];

			TOGGLE.addEventListener('click', (e) => {
				e.preventDefault();

				// update page number
				this.data.pagenumber = parseInt( TOGGLE.getAttribute('data-page') );

				// ajax call
				this.filterArticles();

				// set url
				this.buildUrl();

				// scroll top
				this.scrollToTop();

			});
		}
	}

	filterArticles() {

		this.showLoader();

		$.post(main_theme_objects.ajax_url, this.data, (response) => {
            if (response != 0) {

				if (this.ARTICLES_WRAP) this.ARTICLES_WRAP.innerHTML = response.markup;

				if (this.PAGINATION_WRAP) {
					this.PAGINATION_WRAP.innerHTML = response.pagination;
					this.paginationToggleHandler(); // reinit pagination
				}

				new ObjectFitClass(); // re-run objectfit

				this.hideLoader();
            }
		});
	}

	buildUrl () {
		let parametersString = this.url
		const parameters = []

		// add pagenumber
		if ('pagenumber' in this.data && parseInt(this.data.pagenumber) > 1) {
			parameters.push(`pagenumber=${this.data.pagenumber}`)
		}

		// add cat
		if ('category' in this.data && parseInt(this.data.category) !== 0) {
			parameters.push(`category=${this.data.category}`)
		}

		if (parameters.length > 0) {
			for (let i = 0; i < parameters.length; i++) {
				parametersString += i === 0 ? '?' : '&'
				parametersString += parameters[i]
			}
		}

		window.history.pushState(`articles_${this.type}`, '', parametersString)
	}


	showLoader() {
		if (this.LOADER) this.LOADER.classList.add('loader--show');
	}

	hideLoader() {
		if (this.LOADER) this.LOADER.classList.remove('loader--show');
	}

	scrollToTop() {

		const HEADER = document.getElementById('main_header');
		const ADMIN_BAR = document.getElementById('wpadminbar');

		let offset = HEADER ? HEADER.getBoundingClientRect().height : 100;
		offset += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0;

		$('html, body').animate({
			scrollTop: $(this.SCROLL_TO_ID).offset().top - offset
		}, 800);
	}
}